import styled from 'styled-components';
import { withTheme } from '@material-ui/core/styles';

const Header = styled.div`
  background-color: ${props => props.theme.palette.primary.dark};
  padding: ${props => props.theme.spacing(1.25)}px ${props => props.theme.spacing(4)}px;
`;

export default withTheme(Header);
